import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import ColorBlock from "./ColorBlock";
import { Color } from "../../../../core/models/entities/LogoOptions";
import { systemColorDisplayName } from "../../../../utils/systemColors";

function ColorBlockWithToolTip({
  color,
  onClick,
  size,
}: {
  color: Color;
  onClick: (color: Color) => void;
  size?: "sm" | "md";
}) {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={systemColorDisplayName(color, t) ?? color.name}
      placement={"right"}
    >
      <div onClick={() => onClick(color)}>
        <ColorBlock size={size} color={color} />
      </div>
    </Tooltip>
  );
}

export default ColorBlockWithToolTip;
